<template>
	<div class="content-box-wrapper finished-modules">
		<div class="content-box-header">
			<h2 class="content-box-header__headline text-17">
				Dina avklarade moduler
			</h2>
		</div>
		<div class="content-box-padding loading-spinner-wrapper">
			<LoadingSpinner v-if="!loaded.modules" />
			<div v-if="modules.length">
				<div v-if="loaded.modules && !finishedModules.length">
					<p>Du har inga avklarade moduler.</p>
				</div>
				<div
					class="row row-slider"
					v-if="loaded.modules && finishedModules.length"
				>
					<ModuleCard
						v-for="module in finishedModules"
						:module="module"
						:key="module.name"
						class="col-9 col-sm-6 col-xl-4 margin-bottom-xs-2"
					/>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import getModules from "./../mixins/getModules.vue";
import LoadingSpinner from "./../partials/LoadingSpinner.vue";
import ModuleCard from "./ModuleCard.vue";

export default {
	name: "FinishedModules",
	props: [],
	components: { LoadingSpinner, ModuleCard },
	mixins: [getModules],
	computed: {
		modules() {
			return this.$store.state.modules;
		},
		finishedModules() {
			return this.getModules("finished");
		},
		loaded() {
			return this.$store.state.loaded;
		}
	},
	methods: {},
	mounted() {}
};
</script>